$(document).on "turbolinks:load", ->
  $("[data-devicelink]").click ->
    Turbolinks.visit(this.dataset.devicelink)
